import type { CalendarEvent } from "../Models/Domain";
import type { CalendarEventUpdateQueryApi } from "../Models/Api";

import CalendarEventTransformer from "@/Modules/Transformers/Calendars/Event";
import { updateEvent } from "@/Services/TherapyApi/Calendars";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import useCalendarsStore from "../Store";

import { isValidString } from "@/Utils/String";

const UpdateEventActionHandler = async (
  event: Omit<CalendarEvent, "isEditable">
): Promise<CalendarEvent | undefined> => {
  const payload: Omit<CalendarEventUpdateQueryApi, "patient_uuid"> = {
    description: isValidString(event.description) ? event.description : null,
    end_at: event.endAt,
    start_at: event.startAt,
    summary: event.summary,
    time_zone: event.timeZone,
  };

  if (isValidString(event.patientUuid)) {
    (payload as CalendarEventUpdateQueryApi).patient_uuid = event.patientUuid;
  }

  const resp = await updateEvent(event.calendarUuid, event.uuid, payload as CalendarEventUpdateQueryApi);

  if (isApiError(resp)) return undefined;

  const calendarEvent = CalendarEventTransformer.toDomain(resp);
  const calendarsStore = useCalendarsStore();

  calendarsStore.events = calendarsStore.events.map((e) => {
    if (e.uuid === event.uuid) {
      return calendarEvent;
    }

    return e;
  });

  return calendarEvent;
};

export default UpdateEventActionHandler;
